import React from 'react';
import { Box } from '@mui/material';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import DosenTooltip from './DosenTooltip';

export type ProgramKind = 'assessment' | 'training';

const KIND: Record<ProgramKind, { label: string; Icon: typeof SchoolOutlinedIcon }> = {
  assessment: { label: 'Assessment', Icon: FactCheckOutlinedIcon },
  training: { label: 'Training', Icon: SchoolOutlinedIcon }
};

/**
 * What kind of program a card is, as a small icon at the end of its name pill
 * (the category's colour dot is at the start): an Assessment measures, a
 * Training teaches. The word is on hover. Used on the admin and learner cards.
 */
const ProgramKindIcon: React.FC<{ kind: ProgramKind; size?: number }> = ({ kind, size = 15 }) => {
  const { label, Icon } = KIND[kind];
  return (
    <DosenTooltip title={label} placement="top">
      <Box component="span" aria-label={label} sx={{ flex: '0 0 auto', display: 'inline-flex', color: '#B6B6B6' }}>
        <Icon sx={{ fontSize: size, display: 'block' }} />
      </Box>
    </DosenTooltip>
  );
};

export default ProgramKindIcon;
